var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUltimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ultimate Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.3921 24L0 17.9998V6.00023L10.3921 0L20.7843 6.00023V17.9998L10.3921 24ZM0.917466 17.4704L10.3921 22.9403L19.8668 17.4704V6.52961L10.3921 1.05968L0.917466 6.52961V17.4704Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.375 9.19027C15.3704 9.99856 15.142 10.7546 14.7924 11.472C13.8006 13.507 12.5513 14.9181 10.3436 16.1951C9.68854 16.574 8.98851 16.852 8.23435 16.9722C7.76736 17.0474 7.30221 17.0585 6.84348 16.9236C5.99482 16.675 5.54893 16.0566 5.43975 15.24C5.32232 14.3703 5.55719 13.5565 5.90491 12.7666C5.89849 12.8133 5.89482 12.8611 5.88748 12.906C5.8205 13.2675 5.80307 13.6299 5.92785 13.9794C6.13795 14.5703 6.61411 14.885 7.28294 14.8887C7.92884 14.8923 8.52244 14.6868 9.07659 14.3831C10.7335 13.4785 11.9996 12.1876 12.8336 10.4876C13.0731 9.99765 13.2272 9.48111 13.2309 8.92788C13.2373 7.95812 12.6125 7.36452 11.64 7.42874C11.4528 7.43975 11.2675 7.47553 11.0721 7.48563C11.2611 7.41039 11.4464 7.33149 11.6382 7.26451C12.307 7.03056 12.9896 6.89569 13.6988 7.01863C14.3685 7.13606 14.8759 7.48379 15.1658 8.11684C15.1722 8.13336 15.1906 8.14436 15.2034 8.15904C15.2539 8.34437 15.3062 8.53153 15.3576 8.71686C15.3621 8.87466 15.3741 9.03247 15.3741 9.19027H15.375Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.8212 8.88016C12.8276 9.38569 12.6799 9.85635 12.4616 10.3004C11.645 11.9592 10.411 13.217 8.77428 14.0758C8.54216 14.1978 8.28436 14.2776 8.02471 14.385C7.8137 14.4125 7.58892 14.4629 7.36414 14.473C6.65218 14.5024 6.25033 14.1051 6.25492 13.3895C6.25951 12.8611 6.42282 12.3711 6.65952 11.9096C7.4935 10.2912 8.7174 9.05356 10.3386 8.22234C10.7872 7.99297 11.267 7.837 11.7827 7.84342C12.4414 7.85168 12.8121 8.22234 12.8203 8.88108L12.8212 8.88016Z",
    fill: "#F2F2F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUltimate);
export default __webpack_public_path__ + "static/media/ic_ultimate.3ebfe8a266941afed2261c628dd9ef03.svg";
export { ForwardRef as ReactComponent };